import WarningIcon from '@mui/icons-material/Warning';
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import React, { FC, ReactElement, ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTitleWithClose } from '../dialog-title-with-close/dialog-title-with-close.component';

interface Props {
    button: ReactElement;
    title: string;
    text: string | ReactNode;
    onConfirm: () => void;
}

export const ConfirmModal: FC<Props> = ({ button, title, text, onConfirm }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const handleConfirm = useCallback(() => {
        setIsOpen(false);
        onConfirm();
    }, [onConfirm]);

    const onCancel = useCallback(() => setIsOpen(false), []);

    return (
        <>
            {React.cloneElement(button, {
                // eslint-disable-next-line
                // @ts-ignore
                onClick: (event: MouseEvent) => {
                    event.stopPropagation();
                    setIsOpen(true);
                },
            })}

            <Dialog open={isOpen} onClose={onCancel}>
                <DialogTitleWithClose onClose={onCancel}>
                    <Grid container direction="row" alignItems="center">
                        <WarningIcon color="secondary" style={{ marginRight: '0.5em' }} />
                        {title}
                    </Grid>
                </DialogTitleWithClose>
                <DialogContent>{text}</DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleConfirm}
                        color="secondary"
                        autoFocus
                        variant="contained"
                        aria-label="confirm"
                    >
                        {t('confirm')}
                    </Button>
                    <Button onClick={onCancel} color="secondary">
                        {t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
